import Crud from '../views/VehicleIpva/Crud'
import Entity from '../views/VehicleIpva/Add'

let routes = {
    path: '/vehicle_ipvas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicle_ipvas/add',
            name: 'NewVehicleIPVA',
            component: Entity,
            meta: {
                ability: 'ipva.gerenciar',
                pageTitle: 'IPVA',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_ipvas'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_ipvas/edit/:id?',
            name: 'EditVehicleIPVA',
            component: Entity,
            meta: {
                ability: 'ipva.gerenciar',
                pageTitle: 'IPVA',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_ipvas'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_ipvas',
            name: 'list-vehicle-ipvas',
            component: Crud,
            meta: {
                ability: 'ipva.ver',
                pageTitle: 'IPVA',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
